import React, { useMemo, useState } from 'react';
import useStore from 'store/AccountStore';
import OpSelect from 'op2mise-react-widgets/OpSelect/OpSelect';
import useSwitchOrganisation from 'hooks/useSwitchOrganisation';
import SwitchOrganisationModal from 'shared/components/switch-organisation-modal/SwitchOrganisationModal';
import styles from './OrganisationSelect.module.css';

const ORGANISATION_FIELDS = { text: 'name', value: 'id' };
const NO_ORGANISATION_PLACEHOLDER = 'No organisation';

function OrganisationSelect() {
  const { user } = useStore((state) => state);
  const {
    cancelSwitch,
    confirmSwitchAsync,
    isSwitching,
    pendingOrganisation,
    requestSwitchAsync,
  } = useSwitchOrganisation();
  // Changing the key remounts the dropdown so it shows the current organisation again
  const [selectKey, setSelectKey] = useState(0);

  const organisations = useMemo(
    () =>
      (user?.organisations ?? []).map((org) => ({
        id: org.organisationId,
        name: org.name,
      })),
    [user?.organisations]
  );

  const handleChangeAsync = async (organisation) => {
    const didHandle = await requestSwitchAsync(organisation);
    if (!didHandle) setSelectKey((key) => key + 1);
  };

  const handleCancel = () => {
    cancelSwitch();
    setSelectKey((key) => key + 1);
  };

  const handleConfirmAsync = async () => {
    const didSwitch = await confirmSwitchAsync();
    if (!didSwitch) setSelectKey((key) => key + 1);
  };

  return (
    <div className={styles.organisationSelect}>
      <label>Organisation:</label>
      <OpSelect
        key={selectKey}
        dataSource={organisations}
        enabled={!isSwitching}
        fields={ORGANISATION_FIELDS}
        onChange={(e) => {
          handleChangeAsync(e.target.itemData);
        }}
        placeholder={NO_ORGANISATION_PLACEHOLDER}
        value={user?.organisationId ?? null}
        width={200}
      />
      <SwitchOrganisationModal
        show={!!pendingOrganisation}
        isLoading={isSwitching}
        onCancel={handleCancel}
        onConfirm={handleConfirmAsync}
      />
    </div>
  );
}

export default OrganisationSelect;
